/* eslint-disable import/prefer-default-export */
import { onMounted, onUnmounted, getCurrentInstance } from '@vue/composition-api'
import PusherClient from '@/libs/pusher'
import { createRealtimeRefreshScheduler } from '@/views/orders/Planner/setup'

export const usePlannerRealtime = fetchFn => {
  const instance = getCurrentInstance()
  const realtimeRefreshHandler = createRealtimeRefreshScheduler(fetchFn)
  let pusherHandler = null

  onMounted(() => {
    pusherHandler = () => realtimeRefreshHandler()
    PusherClient.bind('update', 'order', pusherHandler, instance?.proxy)
  })

  onUnmounted(() => {
    if (pusherHandler) {
      PusherClient.unbind('update', 'order', pusherHandler, instance?.proxy)
      pusherHandler = null
    }
  })
}
